import React from 'react';
import { ShieldAlert } from 'lucide-react';

// BS3-005: staff whose NDIS Worker Screening is not finished stay visible in every staff picker, locked, with this badge.
const LABELS = { MISSING: 'Screening missing', EXPIRED: 'Screening expired', UNVERIFIED: 'Screening not verified' };

export const screeningLabel = (state) => LABELS[String(state || '').toUpperCase()] || (state ? 'Screening incomplete' : '');

/** A locked row keeps full colour (the picker would otherwise fade it to 50%) so the name and badge stay readable. */
export const LOCKED_ROW_CLASS = 'data-[disabled=true]:opacity-100 data-[disabled=true]:cursor-not-allowed';

export function ScreeningBadge({ state, className = '' }) {
  const label = screeningLabel(state);
  if (!label) return null;
  return (
    <span className={`inline-flex items-center gap-1 shrink-0 rounded-full border border-amber-400 bg-amber-50 px-1.5 py-0.5 text-[10px] font-medium text-amber-800 ${className}`}
      data-testid={`screening-badge-${String(state).toUpperCase()}`}>
      <ShieldAlert className="w-3 h-3" /> {label}
    </span>
  );
}

/** Picker row note: the screening badge when screening is the issue (plus any other reason), else the plain red reason. */
export function EligibilityNote({ elig }) {
  if (!elig?.disabled) return null;
  if (elig.screening) {
    const others = (elig.reason || '').replace(/^Not eligible — /, '').split('; ').filter((r) => r && !/screening/i.test(r));
    return (
      <>
        <ScreeningBadge state={elig.screening} />
        {others.length > 0 && <span className="text-[10px] text-red-700 truncate">{others.join('; ')}</span>}
      </>
    );
  }
  return <span className="text-[10px] text-red-700 truncate">{elig.reason}</span>;
}

export default ScreeningBadge;
